import { type TeamMode } from "@common/constants";
import type { ModeName } from "@common/definitions/modes";

import { parseRegions } from "./utils/regionConfig";

const localRegions: Record<string, Region> = {
    dev: { name: "Local Server", mainAddress: "http://127.0.0.1:8000", gameAddress: "ws://127.0.0.1:<gameID>", offset: 8001 }
};
const configured = import.meta.env.VITE_MOMO_REGIONS as string | undefined;
const regions = configured ? parseRegions(configured) : localRegions;
export const Config: ConfigType = { regions, defaultRegion: Object.keys(regions)[0], environment: import.meta.env.VITE_MOMO_ENVIRONMENT === "staging" ? "staging" : "local" };
export interface ConfigType {
    readonly environment: "local" | "staging"
    readonly regions: Record<string, Region>
    readonly defaultRegion: string
}

export interface Region {
    /**
     * The human-readable name of the region, displayed in the server selector.
     */
    readonly name: string

    /**
     * An emoji flag to display alongside the region name.
     */
    readonly flag?: string

    /**
     * The address of the region's main server.
     */
    readonly mainAddress: string

    /**
     * Pattern used to determine the address of the region's game servers.
     * The string `<gameID>` is replaced by the `gameID` given by the /getGame API, plus {@linkcode offset}.
     * For example, if `gameID` is 0, `gameAddress` is `"wss://na.suroi.io/game/<gameID>"`, and `offset` is 1, the resulting address will be wss://na.suroi.io/game/1.
     */
    readonly gameAddress: string

    /**
     * Number to increment `gameID` by when determining the game address. See {@linkcode gameAddress} for more info.
     */
    readonly offset: number
}

export interface ServerInfo {
    readonly protocolVersion: number
    readonly playerCount: number
    readonly teamMode: TeamMode
    readonly teamModeSwitchTime: number
    readonly mode: ModeName
    readonly modeSwitchTime: number
}
